// src/components/login/AdminLogin.js — FULL UPDATED CODE
import { useState } from "react";
import { client } from "../../sanityClient";
import "./AdminLogin.css";

export default function AdminLogin({ onLogin }) {
    const [adminName, setAdminName] = useState("");
    const [adminPassword, setAdminPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            const query = `*[_type == "admin" && adminName == $adminName && adminPassword == $adminPassword][0]`;
            const admin = await client.fetch(query, { adminName, adminPassword });

            if (admin) {
                localStorage.setItem("admin", JSON.stringify(admin));
                onLogin(admin);
            } else {
                setError("Invalid credentials");
            }
        } catch (err) {
            setError("Login failed. Try again.");
        } finally {
            setLoading(false);
        }
    };

    // Clear error when typing
    const handleInputChange = () => {
        if (error) setError("");
    };

    return (
        <div className="login-wrapper">
            <div className="login-card">
                <div className="text-center mb-4">
                    <h1 className="login-title">Uttam Kirana</h1>
                    <p className="login-subtitle">Welcome back, Admin</p>
                </div>

                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label className="form-label">Admin Name</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter admin name"
                            value={adminName}
                            onChange={(e) => {
                                setAdminName(e.target.value);
                                handleInputChange();
                            }}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Enter password"
                            value={adminPassword}
                            onChange={(e) => {
                                setAdminPassword(e.target.value);
                                handleInputChange();
                            }}
                            required
                        />
                    </div>

                    {error && <div className="alert">{error}</div>}

                    <button type="submit" className="btn-login" disabled={loading}>
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>

                <div className="login-footer">
                    © 2025 Uttam Kirana | Powered by Engineerg.com
                </div>
            </div>
        </div>
    );
}